var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SkillStatus } from '../../../../constants/statuses';
import { defaultSort, getGradeSkillLevel } from '../../tableConfig';
var SkillLevelsWeights = {
    above: 10,
    on: 5,
    below: 1,
    tbd: 0,
};
var mapGrades = function (grades, groupGradeValue) {
    return grades.map(function (el) {
        var gradeLevel = getGradeSkillLevel(el.value, groupGradeValue);
        return __assign(__assign({}, el), { level: gradeLevel });
    });
};
var mapStudents = function (students, grades) {
    return students.map(function (student) {
        var studentLevel = 'tbd';
        var skills = student.skills.map(function (skill) {
            var _a = grades.find(function (el) {
                return el.skills.some(function (it) { return it.id === skill.skillId; });
            }), gradeValue = _a.value, gradeLevel = _a.level;
            if (skill.status !== SkillStatus.NoData &&
                SkillLevelsWeights[studentLevel] < SkillLevelsWeights[gradeLevel]) {
                studentLevel = gradeLevel;
            }
            return __assign(__assign({}, skill), { gradeValue: gradeValue, level: gradeLevel });
        });
        return __assign(__assign({}, student), { skills: skills, level: studentLevel });
    });
};
export var mapGroupSkills = function (_a, groupGradeValue) {
    var grades = _a.grades, students = _a.students;
    var mappedGrades = mapGrades(grades, groupGradeValue);
    return {
        grades: mappedGrades,
        students: mapStudents(students, mappedGrades),
    };
};
var TABLE_GROUPS_IN_ORDER = [
    'above',
    'on',
    'below',
    'tbd',
];
export var groupStudentsBySkillsLevel = function (students) {
    return TABLE_GROUPS_IN_ORDER.reduce(function (acc, current) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[current] = students
            .filter(function (el) { return el.level === current; })
            .sort(defaultSort), _a));
    }, {});
};
var TableTitlesByGroup = {
    above: 'Above graders',
    on: 'On graders',
    below: 'Below graders',
    tbd: 'TBD',
};
export var addTitleRowsIntoStudents = function (groupedStudents) {
    return TABLE_GROUPS_IN_ORDER.reduce(function (acc, current) {
        if (groupedStudents[current].length === 0)
            return acc;
        var titleRow = {
            level: current,
            name: TableTitlesByGroup[current],
        };
        return __spreadArray(__spreadArray(__spreadArray([], acc, true), [titleRow], false), groupedStudents[current], true);
    }, []);
};
